import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import styles from './styles.scss'

const TabBar = (props) => {
  const {
    invertColors, items, selectedItemKey, style,
  } = props

  if (!items){
    return null
  }

  return (
    <ul className={classnames(styles.root, invertColors ? styles.invertColors : null)} style={style}>
      {items.map((item) => {
        const {
          icon, href, key, onClick, title, hidden,
        } = item

        if (hidden) return null

        const active = selectedItemKey && key === selectedItemKey

        return (
          <li key={key} className={classnames(styles.tab, active ? styles.active : null)}>
            <a href={href} onClick={onClick}>
              {icon && <FontAwesomeIcon className={styles.icon} icon={icon} />}
              <span>{title}</span>
            </a>
          </li>
        )
      })}
    </ul>
  )
}

TabBar.propTypes = {
  selectedItemKey: PropTypes.string,
  invertColors: PropTypes.bool,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      href: PropTypes.string,
      icon: PropTypes.object,
      key: PropTypes.string.isRequired,
      onClick: PropTypes.func,
      title: PropTypes.string.isRequired,
    }),
  ),
  style: PropTypes.object,
}

export default TabBar
